import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import FormControlLabel from '@material-ui/core/FormControlLabel';

import { mediaNoBannerStatistics, noBannerPayType } from 'lib/api/media';

import MbCheckbox from 'components/atoms/MbCheckbox';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import NewTableContainer from 'components/molecules/NewTable';
import FilterCollection from 'components/organisms/FilterCollection';

const NoBannerStatistics = () => {
  const { t } = useTranslation();

  const initParams = {
    sort: 'desc',
    order: 'STATS_DTTM',
    payType: 'all',
    pltfomTpCode: 'all',
    solType: false,
    sDate: moment().format('YYYYMM01'),
    eDate: moment().format('YYYYMMDD'),
  };

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const [filterList, setFilterList] = useState({
    payType: [],
  });

  useEffect(() => {
    noBannerPayType()
      .then((response) => {
        const { data } = response.data;
        let newFilterList = {
          payType: data,
        };
        setFilterList(newFilterList);
      })
      .catch((error) => {});
    // eslint-disable-next-line
  }, []);

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  const customized = {
    SPNAME: {
      merged: true,
    },

    PAY_TYPE: {
      merged: true,
    },

    ORDER_NUMBER: {
      merged: true,
    },
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const handleChangeValue = (e) => {
    const { name } = e.target;
    const newParams = {
      ...params,
      [name]: !params[name],
    };
    getParam(newParams);
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={params}
          getParam={getParam}
          useDisplayFilter={false}
          useExternalFilter={false}
        />
        <FilterCollection
          label={t('정산방식')}
          name="payType"
          type="checkbox"
          labelKey="CODE_VAL"
          valueKey="CODE_ID"
          list={filterList.payType}
          params={params}
          callBack={getParam}
          useSubmit
          submitTitle={t('확인')}
        />
        <FormControlLabel
          control={
            <MbCheckbox
              name="solType"
              onChange={handleChangeValue}
              checked={params.solType}
            />
          }
          label="베이스 off & 새탭 지면 제외"
        />
      </NewFilterWrap>
      <NewTableContainer
        dataReqPromise={mediaNoBannerStatistics}
        params={{
          ...params,
          solType: params.solType ? 'Y' : 'N',
          payType: params.payType === '' ? null : params.payType,
        }}
        customized={customized}
        getParam={getParam}
        useSearch={false}
        useFetch={false}
        rowsPerPage={50}
      />
    </>
  );
};

export default withRouter(NoBannerStatistics);
